export default (element: HTMLElement) => {
  // This component handles showing/hiding competition type-specific fields

  if (!(element instanceof HTMLFormElement)) {
    console.error(
      'competitionForm component must be attached to a form element',
    );
    return;
  }

  const form = element;
  const competitionTypeSelect = form.querySelector<HTMLSelectElement>(
    'select[name="competition_type"]',
  );

  if (!competitionTypeSelect) {
    console.error('No competition_type select found in form');
    return;
  }

  // Get all SZ-only fields
  const szOnlyFields = form.querySelectorAll<HTMLElement>(
    '[data-competition-type-field="sz-only"]',
  );

  // Function to update field visibility based on competition type
  const updateFieldVisibility = () => {
    const competitionType = competitionTypeSelect.value;
    const isSZ = competitionType === 'sz';

    szOnlyFields.forEach((field) => {
      if (isSZ) {
        field.style.display = '';
        // Make the input required for SZ
        const input =
          field.querySelector<HTMLInputElement>('input[type="date"]');
        if (input) {
          input.required = true;
        }
      } else {
        field.style.display = 'none';
        // Clear the value and make it not required when hidden
        const input =
          field.querySelector<HTMLInputElement>('input[type="date"]');
        if (input) {
          input.value = '';
          input.required = false;
        }
      }
    });
  };

  // Add event listener to competition type select
  competitionTypeSelect.addEventListener('change', updateFieldVisibility);

  // Initial state check
  updateFieldVisibility();
};
